webpackJsonp([3],{

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Regis_vue__ = __webpack_require__(307);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0133629b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Regis_vue__ = __webpack_require__(315);
function injectStyle (ssrContext) {
  __webpack_require__(313)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Regis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0133629b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Regis_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fcccfea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderView_vue__ = __webpack_require__(234);
var normalizeComponent = __webpack_require__(7)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fcccfea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"position":"relative","padding":"0px"}},[_c('h1',{staticClass:"text-white",style:({ 'font-size': _vm.$store.state.screenWidth <=320 ? '24px':'32px' })},[_vm._v("RMUTL Open House")]),_vm._v(" "),_c('span',{staticClass:"badge badge-pill bg-rmutl p-2",staticStyle:{"font-family":"'Mitr', sans-serif"}},[_vm._v("มหาวิทยาลัยเทคโนโลยีราชมงคลล้านนา")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadList_vue__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill__ = __webpack_require__(300);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueBootstrapTypehead',

  components: {
    VueBootstrapTypeaheadList: __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadList_vue__["a" /* default */]
  },

  props: {
    size: {
      type: String,
      default: null,
      validator: function validator(size) {
        return ['lg', 'sm'].indexOf(size) > -1;
      }
    },
    value: {
      type: String
    },
    data: {
      type: Array,
      required: true,
      validator: function validator(d) {
        return d instanceof Array;
      }
    },
    serializer: {
      type: Function,
      default: function _default(d) {
        return d;
      },
      validator: function validator(d) {
        return d instanceof Function;
      }
    },
    backgroundVariant: String,
    textVariant: String,
    inputClass: {
      type: String,
      default: ''
    },
    maxMatches: {
      type: Number,
      default: 10
    },
    minMatchingChars: {
      type: Number,
      default: 2
    },
    placeholder: String,
    prepend: String,
    append: String
  },

  computed: {
    sizeClasses: function sizeClasses() {
      return this.size ? 'input-group input-group-' + this.size : 'input-group';
    },
    formattedData: function formattedData() {
      var _this = this;

      if (!(this.data instanceof Array)) {
        return [];
      }
      return this.data.map(function (d, i) {
        return {
          id: i,
          data: d,
          text: _this.serializer(d)
        };
      });
    }
  },

  methods: {
    resizeList: function resizeList(el) {
      var rect = el.getBoundingClientRect();
      var listStyle = this.$refs.list.$el.style;

      // Set the width of the list on resize
      listStyle.width = rect.width + 'px';

      // Set the margin when the prepend prop or slot is populated
      // (setting the "left" CSS property doesn't work)
      if (this.$refs.prependDiv) {
        var prependRect = this.$refs.prependDiv.getBoundingClientRect();
        listStyle.marginLeft = prependRect.width + 'px';
      }
    },
    handleHit: function handleHit(evt) {
      if (typeof this.value !== 'undefined') {
        this.$emit('input', evt.text);
      }

      this.inputValue = evt.text;
      this.$emit('hit', evt.data);
      this.$refs.input.blur();
      this.isFocused = false;
    },
    handleBlur: function handleBlur(evt) {
      var tgt = evt.relatedTarget;
      if (tgt && tgt.classList.contains('vbst-item')) {
        return;
      }
      this.isFocused = false;
    },
    handleInput: function handleInput(newValue) {
      this.inputValue = newValue;

      // If v-model is being used, emit an input event
      if (typeof this.value !== 'undefined') {
        this.$emit('input', newValue);
      }
    }
  },

  data: function data() {
    return {
      isFocused: false,
      inputValue: ''
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$_ro = new __WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill__["a" /* default */](function (e) {
      _this2.resizeList(_this2.$refs.input);
    });
    this.$_ro.observe(this.$refs.input);
    this.$_ro.observe(this.$refs.list.$el);
  },
  beforeDestroy: function beforeDestroy() {
    this.$_ro.disconnect();
  }
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadListItem_vue__ = __webpack_require__(297);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function sanitize(text) {
  return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueBootstrapTypeaheadList',

  components: {
    VueBootstrapTypeaheadListItem: __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadListItem_vue__["a" /* default */]
  },

  props: {
    data: {
      type: Array,
      required: true,
      validator: function validator(d) {
        return d instanceof Array;
      }
    },
    query: {
      type: String,
      default: ''
    },
    backgroundVariant: {
      type: String
    },
    textVariant: {
      type: String
    },
    maxMatches: {
      type: Number,
      default: 10
    },
    minMatchingChars: {
      type: Number,
      default: 2
    }
  },

  computed: {
    highlight: function highlight() {
      var _this = this;

      return function (text) {
        text = sanitize(text);
        if (_this.query.length === 0) {
          return text;
        }
        var re = new RegExp(_this.escapedQuery, 'gi');

        return text.replace(re, '<strong>$&</strong>');
      };
    },
    escapedQuery: function escapedQuery() {
      return escapeRegExp(sanitize(this.query));
    },
    matchedItems: function matchedItems() {
      if (this.query.length === 0 || this.query.length < this.minMatchingChars) {
        return [];
      }

      var re = new RegExp(this.escapedQuery, 'gi');

      // Filter, sort, and concat
      return this.data.filter(function (i) {
        return i.text.match(re) !== null;
      }).sort(function (a, b) {
        var aIndex = a.text.indexOf(a.text.match(re)[0]);
        var bIndex = b.text.indexOf(b.text.match(re)[0]);

        if (aIndex < bIndex) {
          return -1;
        }
        if (aIndex > bIndex) {
          return 1;
        }
        return 0;
      }).slice(0, this.maxMatches);
    }
  },

  methods: {
    handleHit: function handleHit(item, evt) {
      this.$emit('hit', item);
      evt.preventDefault();
    }
  }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueBootstrapTypeaheadListItem',

  props: {
    data: {},
    htmlText: {
      type: String
    },
    backgroundVariant: {
      type: String
    },
    textVariant: {
      type: String
    }
  },

  data: function data() {
    return {
      active: false
    };
  },


  computed: {
    textClasses: function textClasses() {
      var classes = '';
      classes += this.active ? 'active' : '';
      classes += this.backgroundVariant ? ' bg-' + this.backgroundVariant : '';
      classes += this.textVariant ? ' text-' + this.textVariant : '';
      return 'vbst-item list-group-item list-group-item-action ' + classes;
    }
  }
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a0e87de4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeahead_vue__ = __webpack_require__(301);
function injectStyle (ssrContext) {
  __webpack_require__(294)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0e87de4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a0e87de4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeahead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(295);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(204)("6ece5a52", content, true, {});

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(203)(true);
// imports


// module
exports.push([module.i, ".vbt-autcomplete-list[data-v-a0e87de4]{padding-top:5px;position:absolute;max-height:350px;overflow-y:auto;z-index:999}", "", {"version":3,"sources":["D:/xampp/htdocs/open_house/ui/node_modules/vue-bootstrap-typeahead/src/components/VueBootstrapTypeahead.vue"],"names":[],"mappings":"AACA,uCACE,gBAAiB,AACjB,kBAAmB,AACnB,iBAAkB,AAClB,gBAAiB,AACjB,WAAa,CACd","file":"VueBootstrapTypeahead.vue","sourcesContent":["\n.vbt-autcomplete-list[data-v-a0e87de4] {\n  padding-top: 5px;\n  position: absolute;\n  max-height: 350px;\n  overflow-y: auto;\n  z-index: 999;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25372712_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadList_vue__ = __webpack_require__(299);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25372712_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_bbc90f24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadListItem_vue__ = __webpack_require__(298);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_bbc90f24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.textClasses,attrs:{"tabindex":"0","href":"#"},on:{"mouseover":function($event){_vm.active = true},"mouseout":function($event){_vm.active = false}}},[_vm._t("suggestion",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.htmlText)}})]},null,{ data: _vm.data, htmlText: _vm.htmlText })],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-group shadow"},_vm._l((_vm.matchedItems),function(item,id){return _c('vue-bootstrap-typeahead-list-item',{key:id,attrs:{"data":item.data,"html-text":_vm.highlight(item.text),"background-variant":_vm.backgroundVariant,"text-variant":_vm.textVariant},nativeOn:{"click":function($event){return _vm.handleHit(item, $event)}},scopedSlots:_vm._u([{key:"suggestion",fn:function(ref){
var data = ref.data;
var htmlText = ref.htmlText;
return (_vm.$scopedSlots.suggestion)?[_vm._t("suggestion",null,null,{ data: data, htmlText: htmlText })]:undefined}}],null,true)})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.sizeClasses},[(_vm.$slots.prepend || _vm.prepend)?_c('div',{ref:"prependDiv",staticClass:"input-group-prepend"},[_vm._t("prepend",function(){return [_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(_vm.prepend))])]})],2):_vm._e(),_vm._v(" "),_c('input',{ref:"input",class:("form-control " + _vm.inputClass),attrs:{"type":"search","placeholder":_vm.placeholder,"aria-label":_vm.placeholder,"autocomplete":"off"},domProps:{"value":_vm.inputValue},on:{"focus":function($event){_vm.isFocused = true},"blur":_vm.handleBlur,"input":function($event){return _vm.handleInput($event.target.value)}}}),_vm._v(" "),(_vm.$slots.append || _vm.append)?_c('div',{staticClass:"input-group-append"},[_vm._t("append",function(){return [_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(_vm.append))])]})],2):_vm._e()]),_vm._v(" "),_c('vue-bootstrap-typeahead-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFocused && _vm.data.length > 0),expression:"isFocused && data.length > 0"}],ref:"list",staticClass:"vbt-autcomplete-list",attrs:{"query":_vm.inputValue,"data":_vm.formattedData,"background-variant":_vm.backgroundVariant,"text-variant":_vm.textVariant,"maxMatches":_vm.maxMatches,"minMatchingChars":_vm.minMatchingChars},on:{"hit":_vm.handleHit},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(slot,slotName){return {key:slotName,fn:function(ref){
var data = ref.data;
var htmlText = ref.htmlText;
return [_vm._t(slotName,null,null,{ data: data, htmlText: htmlText })]}}})],null,true)})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_HeaderView_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_typeahead__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_services__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    HeaderView: __WEBPACK_IMPORTED_MODULE_0__layouts_HeaderView_vue__["a" /* default */],
    VueBootstrapTypeahead: __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_typeahead__["a" /* default */]
  },
  data: function data() {
    return {
      school_lists: [],
      citizen_id: '',
      fullname: '',
      tel: '',
      email: '',
      school: '',
      facId: 0,
      isConsent: 0,
      fac_list: [{ id: 1, name: 'คณะบริหารธุรกิจและศิลปศาสตร์' }, { id: 2, name: 'คณะวิทยาศาสตร์และเทคโนโลยีการเกษตร' }, { id: 3, name: 'คณะวิศวกรรมศาสตร์' }, { id: 4, name: 'คณะศิลปกรรมและสถาปัตยกรรมศาสตร์' }, { id: 5, name: 'วิทยาลัยเทคโนโลยีและสหวิทยาการ' }],
      depName: ''
    };
  },

  methods: {
    setIsConsent: function setIsConsent() {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#closeModal').click();
      this.isConsent = 1;
    },
    validateForm: function validateForm() {
      if (this.isConsent !== 1) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#consentRule').click();
      } else if (this.school === '') {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
          title: 'ตรวจสอบ',
          text: 'กรุณากรอกชื่อโรงเรียนปัจจุบัน/school',
          icon: 'warning',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: 'ตกลง',
          denyButtonText: 'ยกเลิก'
        }).then(function (result) {
          console.log('กรุณากรอกชื่อโรงเรียนปัจจุบัน/school');
        });
      } else {
        var $myForm = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#formprofile');
        if (!$myForm[0].checkValidity()) {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#formprofile').addClass('was-validated');
        } else {
          __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#formprofile').removeClass('was-validated');
          this.register();
        }
      }
    },
    register: function register() {
      var _this = this;

      this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__assets_services__["a" /* default */].registerUser(this.$store.state.URL, {
        citizenId: this.citizen_id,
        fullname: this.fullname,
        tel: this.tel,
        email: this.email,
        school: this.school,
        facId: this.facId,
        isConsent: this.isConsent,
        depName: this.depName
      }, this.header, function (result) {
        if (result.status === 'SUCCESS') {
          localStorage.token = result.data.accessToken;
          setTimeout(function () {
            _this.OAuth(_this.citizen_id);
            _this.$router.push('/activity').catch(function () {});
            _this.$store.state.isLoading = false;
          }, 1000);
        } else if (result.status === 'ALREADY_IN_USE') {
          _this.$store.state.isLoading = false;
          _this.$router.push('/activity').catch(function () {});
        } else {
          _this.$store.state.isLoading = false;
          if (_this.school === '') {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
              title: 'ตรวจสอบ',
              text: 'กรุณากรอกชื่อโรงเรียนปัจจุบัน/school',
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'ตกลง',
              denyButtonText: 'ยกเลิก'
            }).then(function (result) {
              console.log(result);
            });
          }
          // Swal.fire({
          //   title: 'ตรวจสอบ',
          //   text: result.message,
          //   icon: 'warning',
          //   showDenyButton: false,
          //   showCancelButton: false,
          //   confirmButtonText: 'เข้าสู่ระบบใหม่',
          //   denyButtonText: 'ยกเลิก',
          // }).then((result) => {
          //   localStorage.clear()
          //   this.$router.push('/').catch(() => {})
          // })
        }
      }, function (_error) {
        _this.$store.state.isLoading = false;
        // localStorage.clear()
        // this.$router.push('/').catch(() => {})
      });
    },
    CheckUser: function CheckUser(citizenId) {
      var _this2 = this;

      this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__assets_services__["a" /* default */].OAuthCheck(this.$store.state.URL, { citizenId: citizenId }, this.header, function (result) {
        if (result.status === 'SUCCESS') {
          _this2.$store.state.isLoading = false;
          localStorage.token = result.data.accessToken;
          _this2.OAuth(citizenId);
          _this2.$router.push('/activity').catch(function () {});
        } else if (result.status === 'NOT_REGISTER') {
          // this.$router.push({ name: 'Regis', params: { id: citizenId } }).catch(() => { })
          _this2.$store.state.isLoading = false;
        } else {
          _this2.$store.state.isLoading = false;
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
            title: 'ตรวจสอบ',
            text: result.message,
            icon: 'warning',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: 'เข้าสู่ระบบใหม่',
            denyButtonText: 'ยกเลิก'
          }).then(function (result) {
            localStorage.clear();
            _this2.$router.push('/').catch(function () {});
          });
        }
      }, function (_error) {
        _this2.$store.state.isLoading = false;
        localStorage.clear();
        _this2.$router.push('/').catch(function () {});
      });
    },
    getSchools: function getSchools() {
      var _this3 = this;

      this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__assets_services__["a" /* default */].schoolData(this.$store.state.URL, this.header, function (result) {
        if (result.status === 'SUCCESS') {
          _this3.$store.state.isLoading = false;
          _this3.school_lists = [];
          result.data.forEach(function (v) {
            _this3.school_lists.push(v['school_name']);
          });
        } else {
          _this3.$store.state.isLoading = false;
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
            title: 'ตรวจสอบ',
            text: result.message,
            icon: 'warning',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: 'เข้าสู่ระบบใหม่',
            denyButtonText: 'ยกเลิก'
          }).then(function (result) {
            localStorage.clear();
            _this3.$router.push('/').catch(function () {});
          });
        }
      }, function (_error) {
        _this3.$store.state.isLoading = false;
        localStorage.clear();
        _this3.$router.push('/').catch(function () {});
      });
    }
  },
  mounted: function mounted() {
    if (this.$route.params.id) {
      this.citizen_id = this.$route.params.id;
      if (this.citizen_id.length === 9 || this.citizen_id.length === 13) {
        this.CheckUser(this.citizen_id);
        this.getSchools();
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#consentRule').click();
      } else {
        localStorage.clear();
        this.$router.push('/').catch(function () {});
      }
    } else {
      this.$router.push('/').catch(function () {});
    }
  }
});

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(314);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(204)("20a13dea", content, true, {});

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(203)(true);
// imports


// module
exports.push([module.i, ".vbt-autcomplete-list[data-v-9a21a6f4]{background-color:#fff!important}", "", {"version":3,"sources":["D:/xampp/htdocs/open_house/ui/src/components/Regis.vue"],"names":[],"mappings":"AACA,uCACE,+BAAqC,CACtC","file":"Regis.vue","sourcesContent":["\n.vbt-autcomplete-list[data-v-9a21a6f4] {\r\n  background-color: #ffffff !important;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('HeaderView'),_vm._v(" "),_c('div',{class:{
      'bg-content': _vm.$store.state.screenWidth > 375,
      'bg-content-se': _vm.$store.state.screenWidth <= 375,
      'bg-content-4': _vm.$store.state.screenWidth <= 320,
    }},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"}),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_vm._m(0),_vm._v(" "),_c('form',{staticClass:"needs-validation",attrs:{"id":"formprofile","novalidate":"","autocomplete":"off"}},[_c('label',{staticClass:"mb-2"},[_vm._v("รหัสบัตรประชาชนหรือเลขพาสปอร์ต/Citizen&Passportid")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.citizen_id),expression:"citizen_id"}],staticClass:"form-control mb-2",staticStyle:{"font-family":"'Mitr', sans-serif"},attrs:{"type":"text","autocomplete":"off","required":"","readonly":""},domProps:{"value":(_vm.citizen_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.citizen_id=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mb-2"},[_vm._v("ชื่อ - นามสกุล/Fullname")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fullname),expression:"fullname"}],staticClass:"form-control mb-2",staticStyle:{"font-family":"'Mitr', sans-serif"},attrs:{"type":"text","autocomplete":"off","required":""},domProps:{"value":(_vm.fullname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fullname=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mb-2"},[_vm._v("เบอร์โทรศัพท์/Telephone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tel),expression:"tel"},{name:"mask",rawName:"v-mask",value:('###-###-####'),expression:"'###-###-####'"}],staticClass:"form-control mb-2",staticStyle:{"font-family":"'Mitr', sans-serif"},attrs:{"type":"text","autocomplete":"off","required":""},domProps:{"value":(_vm.tel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.tel=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mb-2"},[_vm._v("อีเมล/Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control mb-2",staticStyle:{"font-family":"'Mitr', sans-serif"},attrs:{"type":"email","autocomplete":"off","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mb-2"},[_vm._v("สถานศึกษาปัจจุบัน/School")]),_vm._v(" "),_c('vue-bootstrap-typeahead',{staticClass:"mb-2",staticStyle:{"font-family":"'Mitr', sans-serif"},attrs:{"inputClass":"form-control","data":_vm.school_lists},model:{value:(_vm.school),callback:function ($$v) {_vm.school=$$v},expression:"school"}}),_vm._v(" "),_c('label',{staticClass:"mb-2"},[_vm._v("คณะที่สนใจ/faculty")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.facId),expression:"facId"}],staticClass:"form-select mb-2",staticStyle:{"font-family":"'Mitr', sans-serif"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.facId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":0}},[_vm._v("\n                ไม่ทราบ/ยังไม่ตัดสินใจ\n              ")]),_vm._v(" "),_vm._l((_vm.fac_list),function(cp,i){return _c('option',{key:'rcf' + i,domProps:{"value":cp.id}},[_vm._v("\n                "+_vm._s(cp.name)+"\n              ")])})],2),_vm._v(" "),_c('label',{staticClass:"mb-2"},[_vm._v("หลักสูตรที่สนใจ/major")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.depName),expression:"depName"}],staticClass:"form-control mb-2",staticStyle:{"font-family":"'Mitr', sans-serif"},attrs:{"rows":"2","type":"text","autocomplete":"off"},domProps:{"value":(_vm.depName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.depName=$event.target.value}}})],1),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center pb-5"},[_c('button',{staticClass:"btn bg-rmutl text-white",staticStyle:{"width":"48%","font-size":"22px","font-family":"'Mitr', sans-serif"},on:{"click":_vm.validateForm}},[_c('i',{staticClass:"ti ti-device-floppy"}),_vm._v("\n               บันทึก\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn bg-ligth",staticStyle:{"width":"48%","font-size":"22px","font-family":"'Mitr', sans-serif"},on:{"click":function($event){return _vm.$router.push('/')}}},[_c('i',{staticClass:"ti ti-chevron-left"}),_vm._v("\n               ย้อนกลับ\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"})])]),_vm._v(" "),_c('div',{staticStyle:{"height":"100px"}})]),_vm._v(" "),_c('button',{staticStyle:{"display":"none"},attrs:{"type":"button","id":"consentRule","data-bs-toggle":"modal","data-bs-target":"#consentModal"}}),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"consentModal","data-bs-backdrop":"static","data-bs-keyboard":"false","tabindex":"-1","aria-labelledby":"consentModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('h2',{staticClass:"text-center"},[_vm._v("เงื่อนไขและข้อตกลงในการใช้บริการ")]),_vm._v(" "),_c('div',{staticClass:"text-left"},[_vm._v("\n              มหาวิทยาลัยเทคโนโลยีราชมงคลล้านนา (ต่อไปนี้จะแทนด้วย\n            “มทร.ล้านนา”) ได้ตระหนักถึงความสำคัญในการคุ้มครองข้อมูลส่วนบุคคล\n            (Personal Data Protection Policy) ขึ้น\n            โดยนโยบายดังกล่าวจะหมายรวมไปถึงการปฏิบัติต่อข้อมูลส่วนบุคคลของผู้ใช้\n            เช่น การจัดเก็บข้อมูล การเก็บรักษา การประมวลผล การเปิดเผย\n            สิทธิการเข้าถึงข้อมูล รวมถึงสิทธิต่าง ๆ ของแต่ละผู้ใช้เป็นต้น\n            เพื่อให้เจ้าของข้อมูลได้ทราบถึงนโยบายในการคุ้มครองข้อมูลส่วนบุคคล\n            มทร.ล้านนา จึงขอประกาศเงื่อนไขและข้อตกลงการใช้บริการ ดังนี้\n          ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"modal-footer d-flex justify-content-center align-items-center pb-5 pt-3"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.setIsConsent}},[_c('i',{staticClass:"ti ti-check"}),_vm._v("\n               ยอมรับเงื่อนไข\n            ")]),_vm._v(" "),_c('button',{staticStyle:{"display":"none"},attrs:{"type":"button","id":"closeModal","data-bs-dismiss":"modal","aria-label":"Close"}})])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"mt-3",staticStyle:{"font-family":"'Mitr', sans-serif","font-size":"30px"}},[_c('img',{attrs:{"src":"/static/img/icons/apple-touch-icon-60x60.png"}}),_vm._v("\n             ลงทะเบียน\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left mt-2"},[_c('b',[_vm._v("1.คำนิยาม")]),_vm._v(" "),_c('br'),_vm._v("\n              “ผู้ใช้” หมายความว่า บุคคลหรือเจ้าของข้อมูลส่วนบุคคล\n            หรือเป็นบุคคลใด ๆ ที่เกี่ยวข้องกับกิจกรรมและการดำเนินงานต่าง ๆ ที่\n            มทร.ล้านนา ได้ทำการรวบรวมและประมวลผลข้อมูลส่วนบุคคล\n            "),_c('br'),_vm._v("\n              “ข้อมูลส่วนบุคคล” หมายความว่า ข้อมูลเกี่ยวกับผู้ใช้\n            ซึ่งจะทำให้สามารถระบุตัวตนของบุคคลนั้นได้\n            ไม่ว่าจะทางตรงหรือทางอ้อม\n            แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล\n            "),_c('br'),_vm._v("\n              “ผู้ควบคุมข้อมูลส่วนบุคคล” หมายความว่า\n            บุคคลหรือนิติบุคคลซึ่งมีอำนาจหน้าที่ตัดสินใจเกี่ยวกับการเก็บรวบรวม\n            ใช้หรือเปิดเผยข้อมูลส่วนบุคคล\n            "),_c('br'),_vm._v("\n              “กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล” หมายความว่า\n            พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562\n            และกฎหมายที่เกี่ยวข้อง\n            อีกทั้งให้หมายความรวมถึงกฎหมายฉบับแก้ไขเพิ่มในอนาคต\n            "),_c('br'),_vm._v("\n              “การประมวลผล” หมายความว่า การดำเนินการใด ๆ\n            กับข้อมูลส่วนบุคคลไม่ว่าจะด้วยวิธีการอัตโนมัติหรือไม่ก็ตาม เช่น\n            การบันทึก การวิเคราะห์ การตั้งค่า การประเมิน การตรวจสอบมาตรฐาน\n            การปรับเปลี่ยนหรือการดัดแปลง การเรียกคืน การใช้ การเปิดเผย\n            (โดยการส่ง โอน\n            การเผยแพร่หรือการทำให้สามารถเข้าถึงหรือพร้อมใช้งานโดยวิธีใด ๆ)\n            การจัดเรียง การนำมารวมกัน การลบหรือการทำลาย เป็นต้น\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left mt-2"},[_c('b',[_vm._v("2.การเก็บรวบรวมข้อมูลส่วนบุคคล")]),_vm._v(" "),_c('br'),_vm._v("\n              2.1 ข้อมูลส่วนบุคคลที่ มทร.ล้านนา\n            เก็บรวบรวมภายใต้คำประกาศเกี่ยวกับความเป็นส่วนตัวนี้ ประกอบไปด้วย\n            ชื่อ-นามสกุล อีเมล หมายเลขบัตรประชาชน ชื่อสถานศึกษา\n            คณะที่สนใจและหลักสูตรที่มีความสนใจ\n            "),_c('br'),_vm._v("\n              2.2\n            ในการเก็บรวบรวมนั้นจะทำเพียงเท่าที่จำเป็นแก่การดำเนินงานภายใต้วัตถุประสงค์ของ\n            มทร.ล้านนา เท่านั้น โดยจะดำเนินการให้เจ้าของข้อมูล รับรู้\n            ให้ความยินยอมทางอิเล็กทรอนิกส์ หรือตามแบบวิธีการของ มทร.ล้านนา\n            กรณีที่ มทร.ล้านนา จัดเก็บข้อมูลส่วนบุคคลอ่อนไหวของเจ้าของข้อมูล\n            จะขอความยินยอมจากเจ้าของข้อมูลโดยชัดแจ้งก่อนทำการเก็บรวบรวม\n            เว้นแต่การเก็บข้อมูลส่วนบุคคลและข้อมูลส่วนบุคคลอ่อนไหวจะเข้าข้อยกเว้นตามที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล\n            พ.ศ. 2562 หรือกฎหมายอื่นที่เกี่ยวข้อง\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left mt-2"},[_c('b',[_vm._v("3.วัตถุประสงค์ในการเก็บรวบรวม หรือใช้ข้อมูลส่วนบุคคล")]),_vm._v(" "),_c('br'),_vm._v("\n               3.1 มทร.ล้านนา จะทำการเก็บรวบรวมข้อมูลส่วนบุคคลโดยมี\n            วัตถุประสงค์ ขอบเขต และใช้วิธีการที่ชอบด้วยกฎหมายและเป็นธรรม\n            โดยในการเก็บรวบรวมนั้นจะทำเพียงเท่าที่จำเป็นแก่การดำเนินงานภายใต้\n            วัตถุประสงค์ของ มทร.ล้านนา โดยคำนึงถึงการคุ้มครองข้อมูลส่วนบุคคล\n            "),_c('br'),_vm._v("\n               3.2\n            วัตถุประสงค์ในการเก็บรวบรวมข้อมูลและใช้ข้อมูลส่วนบุคคล\n            "),_c('br'),_vm._v("\n                3.2.1\n            เพื่อนำข้อมูลไปปรับปรุงและพัฒนาระบบดังกล่าวให้ดียิ่งขึ้นและตรงกับความต้องการของผู้ใช้\n            "),_c('br'),_vm._v("\n                3.2.2\n            เพื่อนำข้อมูลการใช้งานดำเนินการประมวลผลเชิงลึก\n            ในรูปแบบฐานข้อมูลขนาดใหญ่\n            สำหรับใช้ในการประเมินประสิทธิภาพและประสิทธิผลของการใช้งานระบบ\n            "),_c('br'),_vm._v("\n               3.3 มทร.ล้านนา\n            ได้เก็บรวบรวมและรับข้อมูลส่วนบุคคลของท่านผ่านช่องทางต่าง ๆ ดังนี้\n            "),_c('br'),_vm._v("\n                3.3.1 ข้อมูลส่วนบุคคลที่ท่านให้ไว้กับ\n            มทร.ล้านนา ท่านอาจให้ข้อมูลส่วนบุคคลแก่ มทร.ล้านนา โดยตรง\n            กรณีนี้มักเกิดขึ้นเมื่อท่านติดต่อกับ มทร.ล้านนา เพื่อสอบถาม\n            กรอกแบบฟอร์มต่าง ๆ โดยทางออนไลน์หรือโดยเอกสาร\n            เพื่อสมัครใช้บริการหรือร่วมกิจกรรม สอบถามข้อมูล\n            หรือให้ความเห็น/คำติชมแก่ มทร.ล้านนา เป็นต้น\n            "),_c('br'),_vm._v("\n                3.3.2\n            ข้อมูลส่วนบุคคลที่เก็บรวบรวมจากท่านโดยอัตโนมัติ มทร.ล้านนา\n            อาจเก็บรวบรวมข้อมูลทางเทคนิคบางอย่างเกี่ยวกับอุปกรณ์\n            กิจกรรมและรูปแบบการเข้าชม ข้อมูลประวัติการใช้งานเว็บไซต์\n            (Browsing) ของท่านโดยอัตโนมัติโดยใช้คุกกี้ (Cookies)\n            และเทคโนโลยีอื่น ๆ ที่คล้ายคลึงกัน\n            รายละเอียดเพิ่มเติมโปรดดูเพิ่มเติมที่ “นโยบายการใช้คุกกี้”\n            "),_c('br'),_vm._v("\n                3.3.3 ข้อมูลส่วนบุคคลที่ มทร.ล้านนา\n            ได้รับมาจากบุคคลหรือหน่วยงานภายนอก มทร.ล้านนา\n            อาจได้รับข้อมูลส่วนบุคคลของท่านมาจากบุคคลภายนอกเป็นครั้งคราว อาทิ\n            ตัวแทน นายหน้า ผู้ให้บริการ และหน่วยงานของรัฐ\n            "),_c('br'),_vm._v("\n              3.4 ในการเก็บรวบรวมข้อมูลส่วนบุคคลของผู้ใช้\n            ผู้ใช้จะได้รับการแจ้งถึงรายละเอียดต่าง ๆ\n            ตามที่ระบุในคำประกาศเกี่ยวกับความเป็นส่วนตัวนี้\n            ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะพื้นฐานทางกฎหมายในการเก็บรวบรวม ใช้\n            และ/หรือเปิดเผยข้อมูลส่วนบุคคลภายใต้วัตถุประสงค์อันชอบด้วยกฎหมาย\n            หรือหากเป็นกรณีที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนดให้ต้องได้รับความยินยอมจากผู้ใช้\n            มทร.ล้านนา\n            จะขอความยินยอมโดยชัดแจ้งจากผู้ใช้เพื่อให้สามารถประมวลผลข้อมูลส่วนบุคคลของผู้ใช้ได้\n            "),_c('br'),_vm._v("\n              3.5\n            ข้อมูลที่ได้จากผู้ใช้จะถูกนำไปประมวลผลและแสดงผลตามวัตถุประสงค์ของการ\n            และจะทำการเปิดเผยตามวัตถุประสงค์ที่แจ้งไว้\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left mt-2"},[_c('b',[_vm._v("4. การเปิดเผยข้อมูลส่วนบุคคล")]),_vm._v(" "),_c('br'),_vm._v("\n               4.1 ข้อมูลส่วนบุคคลที่ได้รับ มทร.ล้านนา\n            จะเก็บรวบรวมข้อมูลต่อเมื่อได้รับความยินยอมจากท่านตามที่กฎหมายกำหนด\n            เว้นแต่มีความจำเป็นตามกรณีที่กฎหมายอนุญาต\n            "),_c('br'),_vm._v("\n                4.1.1 ข้อมูลส่วนบุคคลของท่านที่ มทร.ล้านนา\n            ดำเนินเก็บรวบรวม ใช้ และ/หรือเปิดเผย เช่น ข้อมูลส่วนตัว เช่น\n            ชื่อ-นามสกุล อีเมล หมายเลขบัตรประชาชน\n            "),_c('br'),_vm._v("\n                4.1.2 ข้อมูลเพื่อการประมวลผล ชื่อสถานศึกษา\n            คณะที่สนใจและหลักสูตรที่มีความสนใจ ข้อมูลการเข้าใช้งานระบบ\n            "),_c('br'),_vm._v("\n                4.1.3 ข้อมูลอื่น ๆ เช่น การใช้งานระบบ\n            เสียง ภาพนิ่ง ภาพเคลื่อนไหว\n            และข้อมูลอื่นใดที่ถือว่าเป็นข้อมูลส่วนบุคคลภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคล\n            "),_c('br'),_vm._v("\n               4.2 ข้อมูลส่วนบุคคลที่มีความอ่อนไหว (Sensitive Data)\n            คือ ข้อมูลส่วนบุคคลที่กฎหมายกำหนดเป็นการเฉพาะซึ่ง มทร.ล้านนา\n            จะเก็บรวบรวม ใช้\n            และ/หรือเปิดเผยข้อมูลส่วนบุคคลที่มีความอ่อนไหวต่อเมื่อได้รับความยินยอมโดยชัดแจ้งจากท่าน\n            หรือในกรณีที่มีความจำเป็นตามกรณีที่กฎหมายอนุญาต\n            เพื่อวัตถุประสงค์ในการพิสูจน์และยืนยันตัวตนของผู้ใช้บริการที่ขอสมัคร\n            และ/หรือทำธุรกรรมผ่านช่องทางดิจิทัล เว็บไซต์ หรือช่องทางอื่นใด\n            เป็นต้น\n            "),_c('br'),_vm._v("\n               4.3 ข้อมูลด้านเทคนิค อาทิ\n            ข้อมูลการเข้าใช้งานเว็บไซต์และระบบต่าง ๆ ของ มทร.ล้านนา\n            ข้อมูลจราจรทางคอมพิวเตอร์ (Log)\n            ข้อมูลการติดต่อและสื่อสารระหว่างท่านและผู้ใช้งานรายอื่น\n            ข้อมูลจากการบันทึกการใช้งาน เช่น ตัวระบุอุปกรณ์ หมายเลข IP\n            ของคอมพิวเตอร์ รหัสประจำตัวอุปกรณ์ ประเภทอุปกรณ์\n            ข้อมูลเครือข่ายมือถือ ข้อมูลการเชื่อมต่อ\n            ข้อมูลตำแหน่งที่ตั้งทางภูมิศาสตร์ ประเภทของเบราว์เซอร์ (Browser)\n            ข้อมูลบันทึกการเข้าออกระบบ\n            ข้อมูลแอปพลิเคชันหรือเว็บไซต์ที่ท่านเข้าถึงก่อนและหลัง (Referring\n            Website) ข้อมูลบันทึกประวัติการใช้ระบบ ข้อมูลบันทึกการเข้าสู่ระบบ\n            (Login Log) พฤติกรรมการใช้งาน (Customer Behavior) สถิติการเข้าระบบ\n            เวลาที่เยี่ยมชมระบบ (Access Time) ข้อมูลที่ท่านค้นหา\n            การใช้ฟังก์ชันต่าง ๆ ในระบบ และข้อมูลที่ได้เก็บรวบรวมผ่านคุกกี้\n            (Cookies) หรือเทคโนโลยีอื่นที่คล้ายกัน\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left mt-2"},[_c('b',[_vm._v("5. แนวทางในการดำเนินการคุ้มครองข้อมูลส่วนบุคคล")]),_vm._v(" "),_c('br'),_vm._v("\n              มทร.ล้านนา จะจัดเก็บข้อมูลส่วนบุคคลเท่าที่จำเป็น\n            โดยคำนึงถึงวัตถุประสงค์และความจำเป็น ทั้งนี้ มทร.ล้านนา\n            จะเก็บรักษาข้อมูลส่วนบุคคลของท่านไว้เป็นอย่างดีตามมาตรการป้องกันด้านการบริหารจัดการ\n            (administrative safeguard) มาตรการป้องกันด้านเทคนิค (technical\n            safeguard) และมาตรการป้องกันทางกายภาพ (physical safeguard)\n            เพื่อรักษาความมั่นคงปลอดภัยในการประมวลผลข้อมูลส่วนบุคคลที่เหมาะสม\n            หมายความว่า มีการธำรงไว้ซึ่งความลับ (confidentiality)\n            ความถูกต้องครบถ้วน (integrity)\n            และให้ข้อมูลอยู่ในลักษณะที่พร้อมใช้งาน (availability)\n            และเพื่อป้องกันการละเมิดข้อมูลส่วนบุคคล โดยได้กำหนดนโยบาย ระเบียบ\n            และหลักเกณฑ์ในการคุ้มครองข้อมูลส่วนบุคคล เช่น\n            มาตรฐานความปลอดภัยของระบบเทคโนโลยีสารสนเทศ\n            และมาตรการเพื่อป้องกันไม่ให้ผู้รับข้อมูลไปจาก มทร.ล้านนา\n            ใช้หรือเปิดเผยข้อมูลนอกวัตถุประสงค์ หรือโดยไม่มีอำนาจหรือโดยไม่ชอบ\n            และ มทร.ล้านนา ได้มีการปรับปรุงนโยบาย ระเบียบ\n            และหลักเกณฑ์ดังกล่าวเป็นระยะ ๆ ตามความจำเป็นและเหมาะสม\n            "),_c('br'),_vm._v("\n              โดยสิทธิของท่านในข้อนี้เป็นสิทธิตามกฎหมายที่ท่านควรทราบ\n            โดยท่านสามารถขอใช้สิทธิต่าง ๆ ได้ภายใต้ข้อกำหนดของกฎหมาย\n            และนโยบายที่กำหนดไว้ในขณะนี้หรือที่จะมีการแก้ไขเพิ่มเติมในอนาคต\n            ตลอดจนหลักเกณฑ์ตามที่ มทร.ล้านนา กำหนดขึ้น\n            และในกรณีท่านมีอายุไม่ครบ 20 ปีบริบูรณ์\n            หรือถูกจำกัดความสามารถในการทำนิติกรรมตามกฎหมาย\n            ท่านสามารถขอใช้สิทธิโดยให้บิดาและมารดา ผู้ใช้อำนาจปกครอง\n            หรือมีผู้อำนาจกระทำการแทนเป็นผู้แจ้งความประสงค์\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left mt-2"},[_c('b',[_vm._v("6. สิทธิในการเข้าถึง")]),_vm._v(" "),_c('br'),_vm._v("\n              มทร.ล้านนา\n            ขอสงวนสิทธิในการปรับปรุงหรือแก้ไขช่องทางการให้บริการหรือเนื้อหาใด\n            ๆ บนเว็บไซต์นี้ ในเวลาใด ๆ นอกจากนี้\n            มทร.ล้านนาสงวนสิทธิที่จะปฏิเสธหรือจำกัดการเข้าถึงเว็บไซต์นี้ของบุคคลใด\n            หรือจากเลขที่อยู่อินเตอร์เน็ต (IP Address) ใด\n            โดยไม่จำเป็นต้องบอกกล่าวหรือระบุเหตุผลในการดำเนินการนั้น\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left mt-2"},[_c('b',[_vm._v("7. การทบทวนและเปลี่ยนแปลงนโยบายการคุ้มครองข้อมูลส่วนบุคคล")]),_vm._v(" "),_c('br'),_vm._v("\n               มทร.ล้านนา\n            อาจทำการปรับปรุงหรือแก้ไขนโยบายนี้เป็นครั้งคราวเพื่อให้สอดคล้องกับข้อกำหนดตามกฎหมาย\n            การเปลี่ยนแปลงการดำเนินงานของ มทร.ล้านนา\n            รวมถึงข้อเสนอแนะและความคิดเห็นจากหน่วยงานต่าง ๆ\n            โดยจะทำการประกาศแจ้งการเปลี่ยนแปลงให้ทราบอย่างชัดเจน\n            ก่อนจะเริ่มดำเนินการเปลี่ยนแปลงใด ๆ\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.4b4cf371081ec570b905.js